window.bbaPaidUnitCount = (cart) => (cart.items || []).reduce((sum, item) => {
  const gift = item.properties?._bba_free_gift;
  return Number(item.final_line_price) > 0 && gift !== true && gift !== 'true' ? sum + Number(item.quantity || 0) : sum;
}, 0);

window.bbaTierDiscountCodes = (cart, tenCode = 'BBA-CART10') => {
  const codes = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
  const retained = codes.filter(code => ![tenCode.toLowerCase(), 'bba-cart5'].includes(code.toLowerCase()));
  const count = window.bbaPaidUnitCount(cart);
  if (count >= 3) retained.push(tenCode);
  else if (count >= 2) retained.push('BBA-CART5');
  return retained;
};

class BbaCartGift extends HTMLElement {
  connectedCallback() {
    if (this.dataset.busy === 'true') return;
    const qualified = this.dataset.qualified === 'true';
    const inCart = this.dataset.inCart === 'true';
    if (qualified === inCart) return;
    this.operation = qualified ? 'add' : 'remove';
    this.dataset.busy = 'true';
    const payload = qualified
      ? { items: [{ id: Number(this.dataset.variantId), quantity: 1, properties: { _bba_free_gift: 'true' } }] }
      : { id: this.dataset.lineKey, quantity: 0 };
    this.updateCart(qualified ? routes.cart_add_url : routes.cart_change_url, payload);
  }

  async updateCart(url, payload) {
    const drawer = this.closest('cart-drawer');
    const sections = drawer.getSectionsToRender().map((section) => section.id);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections, sections_url: window.location.pathname }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message);
      drawer.renderContents(state, { open: false });
    } catch (error) {
      console.error(error);
      this.dataset.busy = 'false';
      this.textContent = this.operation === 'add' ? window.bbaCartStrings.addError : window.bbaCartStrings.giftError;
      this.setAttribute('role', 'alert');
    }
  }
}

class BbaCartUpsells extends HTMLElement {
  connectedCallback() {
    this.rotateProducts();
    this.setupMasonry();
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';
    this.querySelectorAll('[data-bba-upsell-variant]').forEach(select => this.selectVariant(select));
    this.addEventListener('change', event => {
      if (event.target.matches('[data-bba-upsell-variant]')) this.selectVariant(event.target);
    });
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bba-cart-add]');
      if (button) this.add(button);
    });
  }

  setupMasonry() {
    if (!this.closest('cart-drawer.bba-cart-enabled') || !window.ResizeObserver) return;
    this.masonryGrid = this.querySelector('.bba-cart-upsells__grid');
    if (!this.masonryGrid) return;
    this.masonryObserver?.disconnect();
    this.masonryObserver = new ResizeObserver(() => {
      cancelAnimationFrame(this.masonryFrame);
      this.masonryFrame = requestAnimationFrame(() => this.layoutMasonry());
    });
    this.masonryObserver.observe(this.masonryGrid);
    this.querySelectorAll('.bba-cart-upsell').forEach(card => this.masonryObserver.observe(card));
    this.layoutMasonry();
  }

  disconnectedCallback() {
    this.masonryObserver?.disconnect();
    cancelAnimationFrame(this.masonryFrame);
  }

  layoutMasonry() {
    const grid = this.masonryGrid;
    if (!grid?.clientWidth) return;
    const cards = Array.from(grid.querySelectorAll('.bba-cart-upsell:not([hidden])'))
      .sort((a, b) => Number(a.style.order || 0) - Number(b.style.order || 0));
    if (!cards.length) return;
    grid.classList.add('is-masonry');
    const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    const columns = Math.max(1, Math.round((grid.clientWidth + gap) / (cards[0].offsetWidth + gap)));
    const bottoms = Array(columns).fill(0);
    cards.forEach(card => {
      const column = bottoms.indexOf(Math.min(...bottoms));
      const height = Math.ceil(card.offsetHeight + gap);
      card.style.gridColumn = String(column + 1);
      card.style.gridRow = `${bottoms[column] + 1} / span ${height}`;
      bottoms[column] += height;
    });
  }

  selectVariant(select) {
    const card = select.closest('.bba-cart-upsell');
    const option = select.selectedOptions[0];
    const button = card.querySelector('[data-bba-cart-add]');
    if (!option || option.disabled) { button.disabled = true; return; }
    button.dataset.bbaCartAdd = option.value;
    button.disabled = false;
    card.querySelector('.bba-cart-upsell__price strong').textContent = option.dataset.price;
    const compare = card.querySelector('.bba-cart-upsell__price s');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const image = card.querySelector('.bba-cart-upsell__media img');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    card.querySelectorAll('.bba-cart-upsell__media, .bba-cart-upsell__title').forEach(link => {
      if (option.dataset.url) link.href = option.dataset.url;
    });
  }

  rotateProducts() {
    const products = Array.from(this.querySelectorAll('.bba-cart-upsell'));
    const configuredLimit = Math.min(4, Math.max(3, Number.parseInt(this.dataset.displayLimit, 10) || 4));
    const isDrawer = Boolean(this.closest('cart-drawer.bba-cart-enabled'));
    const displayLimit = isDrawer
      ? 6 + Math.floor(Math.random() * 3)
      : configuredLimit === 4 && Math.random() < 0.5 ? 3 : configuredLimit;
    if (!isDrawer && products.length <= displayLimit) return;

    const storageKey = 'bba-cart-upsell-last';
    let previousIds = [];
    try {
      previousIds = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]');
    } catch (_error) {
      previousIds = [];
    }

    const freshProducts = products.filter((product) => !previousIds.includes(product.dataset.productId));
    const candidates = freshProducts.length >= displayLimit ? freshProducts : products;

    for (let index = candidates.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [candidates[index], candidates[randomIndex]] = [candidates[randomIndex], candidates[index]];
    }

    const selected = candidates.slice(0, displayLimit);
    products.forEach((product) => {
      product.hidden = true;
      product.style.removeProperty('order');
    });
    selected.forEach((product, index) => {
      product.hidden = false;
      product.style.order = String(index);
    });

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(selected.map((product) => product.dataset.productId)));
    } catch (_error) {
    }
  }

  getDiscountUpdate(cartState) {
    const discountCode = this.dataset.discountCode?.trim();
    if (!discountCode) return null;

    const existingCodes = (cartState.discount_codes || []).map(discount => discount.code).filter(Boolean);
    const desiredCodes = window.bbaTierDiscountCodes(cartState, discountCode);
    const currentKey = existingCodes.map((code) => code.toLowerCase()).sort().join(',');
    const desiredKey = desiredCodes.map((code) => code.toLowerCase()).sort().join(',');

    if (currentKey === desiredKey) return null;
    return desiredCodes;
  }

  showAddedConfirmation(drawer, productTitle) {
    drawer.querySelector('.bba-cart-toast')?.remove();
    const toast = document.createElement('div');
    toast.className = 'bba-cart-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = `${productTitle} — ${window.bbaCartStrings.added}`;
    drawer.querySelector('.drawer__inner')?.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 350);
    }, 1800);
  }

  async add(button) {
    if (button.disabled) return;
    const drawer = this.closest('cart-drawer');
    const error = this.querySelector('.bba-cart-upsells__error');
    const sections = drawer.getSectionsToRender().map((section) => section.id);
    const discountCode = this.dataset.discountCode?.trim();
    const card = button.closest('.bba-cart-upsell');
    const select = card?.querySelector('[data-bba-upsell-variant]');
    if (select) {
      this.selectVariant(select);
      if (button.disabled) return;
      select.disabled = true;
    }
    const productTitle = card?.querySelector('.bba-cart-upsell__title')?.textContent.trim() || '';
    const productId = card?.dataset.productId;
    button.disabled = true;
    button.classList.add('is-loading');
    card?.classList.add('is-adding');
    if (error) error.hidden = true;
    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(button.dataset.bbaCartAdd),
            quantity: 1,
            properties: { _bba_special_offer: 'Quantity offer' },
          }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      let state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message);

      if (discountCode) {
        const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        const cartState = await cartResponse.json();
        if (!cartResponse.ok || cartState.status) throw new Error(cartState.description || cartState.message);
        const discountCodes = this.getDiscountUpdate(cartState);
        if (discountCodes) {
          const discountResponse = await fetch(routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              discount: discountCodes.join(','),
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const discountedState = await discountResponse.json();
          if (!discountResponse.ok || discountedState.status) {
            throw new Error(discountedState.description || discountedState.message);
          }
          state = discountedState;
        }
      }

      drawer.setActiveElement(button);
      drawer.classList.add('bba-is-updating');
      drawer.renderContents(state, { open: false });
      requestAnimationFrame(() => {
        drawer.classList.remove('bba-is-updating');
        const addedRow = productId
          ? drawer.querySelector(`[data-bba-cart-product-id="${productId}"][data-bba-special-offer]`)
          : null;
        if (addedRow) {
          addedRow.classList.add('is-newly-added');
          window.setTimeout(() => addedRow.classList.remove('is-newly-added'), 1500);
        }
        this.showAddedConfirmation(drawer, productTitle);
      });
    } catch (requestError) {
      if (error) {
        error.textContent = requestError.message || window.bbaCartStrings.addError;
        error.hidden = false;
      }
      button.disabled = false;
      button.classList.remove('is-loading');
      card?.classList.remove('is-adding');
    } finally {
      if (select) select.disabled = false;
    }
  }
}

if (!customElements.get('bba-cart-gift')) customElements.define('bba-cart-gift', BbaCartGift);
if (!customElements.get('bba-cart-upsells')) customElements.define('bba-cart-upsells', BbaCartUpsells);

(() => {
 let timer, pending, dirty = false;
 const schedule = () => { clearTimeout(timer); timer = setTimeout(() => sync().catch(showError), 250); };
 const showError = error => { console.warn('BBA discount:', error); const target = document.querySelector('#cart-errors, #CartDrawer-CartErrors'); if (target) { target.textContent = window.bbaCartStrings?.addError || error.message; target.setAttribute('role', 'alert'); } };
 async function run() {
  const response = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to check cart discount.');
  const cart = await response.json();
  const code = document.querySelector('[data-discount-code]')?.dataset.discountCode?.trim() || 'BBA-CART10';
  const existing = (cart.discount_codes || []).map(x => x.code).filter(Boolean);
  const desired = window.bbaTierDiscountCodes(cart, code);
  const key = list => list.map(x => x.toLowerCase()).sort().join(',');
  if (key(existing) === key(desired)) return;
  const ids = ['cart-drawer','cart-icon-bubble',document.querySelector('#main-cart-items')?.dataset.id,document.querySelector('#main-cart-footer')?.dataset.id,document.querySelector('bba-page-offers')?.dataset.section].filter(Boolean);
  const updated = await fetch(routes.cart_update_url, { method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:desired.join(','),sections:ids,sections_url:location.pathname}) });
  const data = await updated.json();
  if (!updated.ok || data.status) throw new Error(data.description || 'Unable to apply cart discount.');
  for (const id of ids) {
   const markup = data.sections?.[id]; if (!markup) continue;
   const doc = new DOMParser().parseFromString(markup,'text/html');
   if (id === 'cart-drawer') { const target=document.querySelector('cart-drawer .drawer__inner'); const next=doc.querySelector('cart-drawer .drawer__inner'); if(target && next)target.innerHTML=next.innerHTML; }
   else if (id === 'cart-icon-bubble') { const target=document.getElementById(id); if(target)target.innerHTML=doc.querySelector('.shopify-section')?.innerHTML || markup; }
   else { const target=document.getElementById('shopify-section-'+id); const next=doc.getElementById('shopify-section-'+id); if(target && next)target.innerHTML=next.innerHTML; }
  }
 }
 function sync() { if(pending){dirty=true;return pending;} pending=run().finally(()=>{pending=null;if(dirty){dirty=false;schedule();}}); return pending; }
 window.bbaSyncPaidDiscount = sync;
 if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
 const observer=new MutationObserver(schedule);
 for(const node of document.querySelectorAll('cart-drawer, #main-cart-items'))observer.observe(node,{childList:true,subtree:true});
 document.addEventListener('submit', async event => {
  const form=event.target;
  if(!event.submitter || event.submitter.name!=='checkout' || form.dataset.bbaDiscountReady==='true')return;
  event.preventDefault(); const button=event.submitter;button.disabled=true;
  try { clearTimeout(timer);if(pending)await pending;await sync();const current=form.id?document.getElementById(form.id):form;const submit=document.querySelector('[name="checkout"][form="'+current.id+'"]') || current.querySelector('[name="checkout"]');current.dataset.bbaDiscountReady='true';button.disabled=false;if(submit){submit.disabled=false;current.requestSubmit(submit);}else{current.dataset.bbaDiscountReady='false';throw new Error('Please retry checkout.');} }
  catch(error){showError(error);button.disabled=false;}
 });
 schedule();
})();


